import { call, put, takeEvery, takeLatest, takeLeading } from "redux-saga/effects";
import { types } from "../action-types";
import { updateProposalApi } from "../../API/API";

function* updateProposalSaga(params) {
  try {
    const response = yield call(updateProposalApi, params);
    yield put({ type: types.UPDATE_PROPOSAL_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.UPDATE_PROPOSAL_FAILURE, error });
  }
}

export function* watchUpdateProposalSaga() {
  yield takeLeading(types.UPDATE_PROPOSAL_REQUESTED, updateProposalSaga);
}
